module.exports = __webpack_public_path__ + "static/trainer1-6385567392d350200ea08ec3317cd707.png";